import register from '../../util/init';
import { updateLinkState } from '../../util/link_state';
import { selectStyles } from '../../util/jquery.formstyles';
import { flickity } from '../../util/flickity';
import handleAjaxPageLoad from '../ajax-page';
import { enableAjaxLoad } from '../site';
import { favouriteAdd } from '../../shoptools/favourites';
// import {bindResource} from './resources';
import { CartAddForm } from '../../shoptools/cart';

function imageZoom (e) {
  let x,
    y,
    offsetX,
    offsetY;
  const zoomer = e.currentTarget;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
  x = offsetX / zoomer.offsetWidth * 100;
  y = offsetY / zoomer.offsetHeight * 100;
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

function collectionProduct (container) {
  // update links
  updateLinkState(document.querySelectorAll('nav.stories'));

  const selectFields = container.querySelectorAll('select:not(.no-style)');
  if (selectFields) {
    selectStyles(selectFields);
  }

  // bind favourite add submit
  container.querySelectorAll('form.add-favourite:not(.initialised)').forEach((form) => {
    favouriteAdd(form);
    form.classList.add('initialised');
  });

  // // bind resource add submit
  // container.querySelectorAll('.resources .resource:not(.initialised)').forEach((resource) => {
  //   bindResource(resource);
  //   resource.classList.add('initialised');
  // });

  // gallery init
  container.querySelectorAll('.gallery').forEach((el) => {
    if (el.childElementCount > 1) {
      const flkty = flickity(el, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
      });

      window.sampleGallery = flkty
    }
  });
  // bind zoom
  container.querySelectorAll('.sample-gallery .image').forEach((im) => {
    window.setTimeout(() => {
      im.setAttribute('style', im.getAttribute('data-style'));
    }, 1000);
    im.addEventListener('mousemove', (e) => {
      imageZoom(e);
    });
  });

  // bind ajax links
  container.querySelectorAll('.ajax-link').forEach((ajaxTrigger) => {
    ajaxTrigger.addEventListener('click', (e) => {
      var modifier = e.shiftKey || e.ctrlKey || e.metaKey;
      if (enableAjaxLoad && !modifier) {
        e.preventDefault();
        handleAjaxPageLoad(ajaxTrigger, 'collection-product');
      }
    });
  });


  // Checkout init
  container.querySelectorAll('.add-form').forEach(formEl => {
    const cartForm = new CartAddForm(formEl);
  })

  // enquiry options
  const questionSelection = container.querySelector('.ask-question select')
  const questionMailto = container.querySelector('.ask-question .mailto')
  if (questionSelection) {
    questionSelection.addEventListener('change', (e) => {
      let href = questionMailto.getAttribute('href')
        .replace(/\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+/, questionSelection.value)
      questionMailto.setAttribute('href', href)
      questionMailto.click()
    })
  }

}
register('collection-product', collectionProduct);



// WEBPACK FOOTER //
// ./assets/j/src/collection/product.js